module.exports = __webpack_public_path__ + "static/media/Quotes-Icon.c0f6ed67.svg";